var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClickUp = function SvgClickUp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_10213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 49.1698L15.1753 41.6307C20.4039 48.4547 25.9591 51.6001 32.1424 51.6001C38.2928 51.6001 43.6908 48.4919 48.6838 41.7216L58.6657 49.0788C51.4614 58.8417 42.5087 64 32.1424 64C21.8092 64 12.7698 58.8747 5.33398 49.1698Z",
    fill: "url(#paint0_linear_415_10213)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1096 16.4009L14.5928 31.4956L6.49567 22.1048L32.1468 0L57.5954 22.1213L49.4611 31.4791L32.1096 16.4009Z",
    fill: "url(#paint1_linear_415_10213)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_10213",
    x1: 5.33398,
    y1: 56.844,
    x2: 58.6657,
    y2: 56.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8930FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49CCF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_415_10213",
    x1: 6.49567,
    y1: 21.4202,
    x2: 57.5954,
    y2: 21.4202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF02F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_10213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClickUp);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzQxNV8xMDIxMykiPgo8cGF0aCBkPSJNNS4zMzM5OCA0OS4xNjk4TDE1LjE3NTMgNDEuNjMwN0MyMC40MDM5IDQ4LjQ1NDcgMjUuOTU5MSA1MS42MDAxIDMyLjE0MjQgNTEuNjAwMUMzOC4yOTI4IDUxLjYwMDEgNDMuNjkwOCA0OC40OTE5IDQ4LjY4MzggNDEuNzIxNkw1OC42NjU3IDQ5LjA3ODhDNTEuNDYxNCA1OC44NDE3IDQyLjUwODcgNjQgMzIuMTQyNCA2NEMyMS44MDkyIDY0IDEyLjc2OTggNTguODc0NyA1LjMzMzk4IDQ5LjE2OThaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfNDE1XzEwMjEzKSIvPgo8cGF0aCBkPSJNMzIuMTA5NiAxNi40MDA5TDE0LjU5MjggMzEuNDk1Nkw2LjQ5NTY3IDIyLjEwNDhMMzIuMTQ2OCAwTDU3LjU5NTQgMjIuMTIxM0w0OS40NjExIDMxLjQ3OTFMMzIuMTA5NiAxNi40MDA5WiIgZmlsbD0idXJsKCNwYWludDFfbGluZWFyXzQxNV8xMDIxMykiLz4KPC9nPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzQxNV8xMDIxMyIgeDE9IjUuMzMzOTgiIHkxPSI1Ni44NDQiIHgyPSI1OC42NjU3IiB5Mj0iNTYuODQ0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM4OTMwRkQiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNDlDQ0Y5Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhcl80MTVfMTAyMTMiIHgxPSI2LjQ5NTY3IiB5MT0iMjEuNDIwMiIgeDI9IjU3LjU5NTQiIHkyPSIyMS40MjAyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNGRjAyRjAiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRkZDODAwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNDE1XzEwMjEzIj4KPHJlY3Qgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";